import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { AmbientGlow, Button, GradientText, Heading } from "../shared";
import { HeroIllustration } from "./HeroIllustration";

/**
 * Landing hero: pill badge, headline with gradient word, lead copy, primary + secondary CTAs,
 * social proof, and the animated right-side illustration.
 *
 * @returns {import("react").ReactElement}
 */
export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden px-6 pt-12 pb-10 md:pt-16 md:pb-14">
      <AmbientGlow color="azure" position="-top-28 -left-28" size="lg" animation="drift" />
      <AmbientGlow
        color="coral"
        position="bottom-[-100px] right-[-80px]"
        size="md"
        animation="drift-reverse"
      />

      <div className="relative z-10 mx-auto grid max-w-310 grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-14">
        <div className="flex flex-col items-center text-center md:items-start md:text-left">
          <Heading as="h1" size="hero" className="text-ink animate-float-in mb-6">
            Grow through{" "}
            <GradientText className="pr-[0.12em] font-medium italic">partnerships</GradientText>{" "}
            built to compound.
          </Heading>

          <p className="font-display text-ink-soft animate-float-in mb-4 max-w-xl text-[clamp(20px,2.4vw,27px)] leading-snug font-medium [animation-delay:80ms]">
            Scale Your Email, SMS List and Social Growth at a Fraction of the Standard Acquisition
            Cost.
          </p>

          <p className="body-lg text-muted animate-float-in mb-8 max-w-xl [animation-delay:160ms]">
            Connect with vetted brands to launch high-performance collaborative campaigns — and
            reach pre-qualified audiences without the sky-high costs of traditional channels.
          </p>

          <div className="animate-float-in mb-9 flex w-full flex-col gap-3 [animation-delay:240ms] sm:w-auto sm:flex-row">
            <Button
              variant="primary"
              href="/app/apply"
              icon={<ArrowForwardIcon fontSize="inherit" sx={{ fontSize: 18 }} />}
              className="w-full justify-center sm:w-auto"
            >
              Apply to Join
            </Button>
            {/* <Button
              variant="soft"
              href="#product-showcase"
              icon={
                <span className="bg-ice text-cerulean inline-flex h-5.5 w-5.5 items-center justify-center rounded-full">
                  <PlayArrowIcon sx={{ fontSize: 14 }} />
                </span>
              }
              iconPosition="leading"
              className="w-full justify-center sm:w-auto"
            >
              Watch demo
            </Button> */}
          </div>

          <div className="animate-float-in border-line shadow-soft flex max-w-md items-center gap-3 rounded-2xl border bg-white/70 py-2.5 pr-5 pl-2.5 backdrop-blur-sm [animation-delay:320ms]">
            <span className="bg-ice inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full">
              <CheckRoundedIcon className="text-teal-deep" sx={{ fontSize: 22 }} />
            </span>
            <p className="text-ink-soft text-left text-[14px] leading-snug font-medium">
              Trusted by top-tier e-commerce, travel &amp; lifestyle brands.
            </p>
          </div>
        </div>

        <div className="animate-float-in [animation-delay:300ms]">
          <HeroIllustration />
        </div>
      </div>
    </section>
  );
}
